import api from "../../../utils/api"
const apiUrl = process.env.REACT_APP_MOCK_RESUME_URL;

export const getProfessionalResumeData = async(page  , limit ,  search) => {
  try {
    const res = await api.get(
      `/transactions/getResumeDownloaded?page=${page}&size=${limit}&search=${search ? search : ""}`,
      { baseURL:  apiUrl}

    );
    return res;
  } catch (err) {
    return err;
  }
}